"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var CrudSimple = __importStar(require("../../crud-simple"));
var utils_1 = __importDefault(require("@nexys/utils"));
var InstanceApp = function (_a) {
    var dataInterface = _a.dataInterface, urlPrefix = _a.urlPrefix, extra = _a.extra;
    var dataDef = {
        urlPrefix: urlPrefix,
        fields: [
            {
                name: 'uuid',
                label: 'UUID',
                type: 'string',
                hide: { detail: true, add: true },
                render: function (x) { return x.uuid.slice(0, 5) + '...'; }
            },
            { name: 'name', label: 'Name', type: 'string', filter: true, sort: true },
            {
                name: 'dateAdded',
                label: 'Date added',
                type: 'date',
                render: function (x) { return utils_1["default"].date.formatDate(x.dateAdded); }
            }
        ]
    };
    return (react_1["default"].createElement(CrudSimple.Generic.App, { dataDef: dataDef, Data: dataInterface, extra: extra }));
};
exports["default"] = InstanceApp;
